module.exports = __webpack_public_path__ + "static/media/tagOval.e63778e3.svg";